import { Row, Col, Card } from "react-bootstrap";
import ModuloTarjeta from "./ModuloTarjeta";

function ModulosDisplay({ modulos = [], onSelectModulo, selectedModulo }) {
  const modulosFiltrados = modulos.filter((m) => m.estado !== "no-disponible");

  return (
    <Card className="p-4 shadow-sm border">
      <p className="h3 mb-3">Módulos</p>
      {modulosFiltrados.length === 0 ? (
        <p className="text-muted">No hay módulos disponibles.</p>
      ) : (
        <Row className="g-3">
          {modulosFiltrados
            .slice()
            .sort((a, b) => a.nombre.localeCompare(b.nombre)) // orden alfabético
            .map((m) => (
              <Col key={m.id} xs={12} md={4}>
                <ModuloTarjeta
                  id={m.id}
                  nombre={m.nombre}
                  numero={m.numero}
                  estado={m.estado}
                  funcionario={m.funcionario}
                  motivos={m.motivos}
                  onSelect={() => onSelectModulo(m)}
                  selectedModulo={selectedModulo}
                />
              </Col>
            ))}
        </Row>
      )}
    </Card>
  );
}

export default ModulosDisplay;